module.exports = __webpack_public_path__ + "img/step-one-enable.ae2463b9.svg";